import { render, staticRenderFns } from "./KitchenChargesPage.vue?vue&type=template&id=4d59bd2a&scoped=true"
import script from "./KitchenChargesPage.vue?vue&type=script&lang=js"
export * from "./KitchenChargesPage.vue?vue&type=script&lang=js"
import style0 from "./KitchenChargesPage.vue?vue&type=style&index=0&id=4d59bd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d59bd2a",
  null
  
)

export default component.exports